import Vue from 'vue'

Vue.prototype.$log = (...b) => console.log(...b)
